import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@express-labs/raven-ui';
import s from './TenderTypeModal.scss';

function TenderTypeModal(props) {
  const {
    deviceWidth,
    handleDismiss,
    handleSubmit,
    isPrefCardModalOpen,
    shouldShowPreferredCardModal,
    topPosition,
    ttpHeaderModalData,
    windowWidth,
  } = props;

  function setLeftPos() {
    const rightUnit = deviceWidth === 'mobile' ? 550 : 582;
    return windowWidth <= 768 ? '5%' : windowWidth - rightUnit;
  }


  const modalStyle = {
    content: {
      top: topPosition + 2,
      left: setLeftPos(),
    },
  };

  return (
    <div data-testid="ttpModalWrapper">
      {shouldShowPreferredCardModal && (
        <Modal
          isOpen={isPrefCardModalOpen}
          isCloseable={false}
          className={s.prefCardModal}
          overlayClassName={s.prefCardModalOverlay}
          ariaHideApp={false}
          onModalClose={handleDismiss}
          style={modalStyle}
        >
          <div className={s.modalContentWrapper} data-testid="modalContentWrapper">
            <h1 data-testid="title">
              {ttpHeaderModalData?.title}
            </h1>
            <p data-testid="bodyText">
              {ttpHeaderModalData?.body?.text}
            </p>
            <div className={s.buttonsWrapper}>
              <Button
                role="button"
                kind="secondary"
                className={s.button}
                onClick={handleDismiss}
              >
                CANCEL
              </Button>
              <Button role="button" kind="primary" className={s.button} onClick={handleSubmit}>
                YES, CHANGE IT
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

TenderTypeModal.propTypes = {
  deviceWidth: PropTypes.string,
  handleDismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isPrefCardModalOpen: PropTypes.bool,
  shouldShowPreferredCardModal: PropTypes.bool,
  topPosition: PropTypes.number,
  ttpHeaderModalData: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  windowWidth: PropTypes.number,
};

TenderTypeModal.defaultProps = {
  deviceWidth: '',
  isPrefCardModalOpen: false,
  shouldShowPreferredCardModal: false,
  topPosition: 0,
  ttpHeaderModalData: { title: '', body: { text: '' } },
  windowWidth: 0,
};

export default TenderTypeModal;
